import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import { phaseChange, reroute, storeDumpItForce } from '../../../actions/Buy'
import { enhancedEcommerceTracker } from '../../../tracking/EnhancedEcommerce/tracker'
import { isNltBrumbrum } from '../../../utils/nltUtils'
import DefaultThanks from '../../dumb/DefaultThanks'
import NltThanks from '../../noleggia/dumb/NltThanks'
import NltBrumbrumThanks from '../../noleggia/smart/NltBrumbrumThanks'
import Faqs from './Faqs'

class Thanks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.toTop = false

    this.faq = Faqs(this.props)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    for (const key in nextProps) {
      if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  componentDidMount() {
    this.props.phaseChange({
      phase: 100,
      last: this.props.ui.last > 100 ? this.props.ui.last : 100,
    })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }
    this.props.storeDumpItForce()

    enhancedEcommerceTracker
      .pushPurchase({
        logistica: this.props.logistica,
        nlt: this.props.nlt,
        ordine: this.props.ordine,
        product: this.props.product,
      })
      .then(() => {})
  }

  render() {
    switch (this.props.payment_method) {
      case 'bank':
        return (
          <DefaultThanks
            {...this.props}
            customer={this.props.customer}
            faqs={this.faq.bank}
            product={this.props.product}
          />
        )
      case 'finanziamento':
        return (
          <DefaultThanks
            {...this.props}
            customer={this.props.customer}
            faqs={this.faq.finanziamento}
            product={this.props.product}
          />
        )
      case 'noleggio':
        if (isNltBrumbrum(this.props.product)) {
          return (
            <NltBrumbrumThanks
              {...this.props}
              customer={this.props.customer}
              faqs={this.faq.noleggioBrumbrum}
              isNltBrumbrumTyFirmato={this.props.isNltBrumbrumTyFirmato}
              product={this.props.product}
            />
          )
        }
        return (
          <NltThanks
            {...this.props}
            customer={this.props.customer}
            faqs={this.faq.noleggioArval}
            product={this.props.product}
          />
        )
      default: {
        // BRUM-14596
        // default when reloading /thank-you page
        return null
      }
    }
  }
}

Thanks.defaultProps = {
  isNltBrumbrumTyFirmato: false,
}

Thanks.propTypes = {
  isNltBrumbrumTyFirmato: PropTypes.bool,
  logistica: PropTypes.object,
  nlt: PropTypes.object,
  ordine: PropTypes.object,
  product: PropTypes.object,
}

const mapStateToProps = state => ({
  logistica: state.logistica,
  product: state.product,
  nlt: state.nlt,
  ordine: state.ordine,
  payment_method: state.payment.method,
  customer: state.customer,
  ui: state.ui,
})

export default connect(mapStateToProps, {
  phaseChange,
  storeDumpItForce,
  reroute,
})(Thanks)
